import reducer, { initialState } from '../../../reducers/userInfo/updateEmail';
import * as actions from '../../../actions/userInfo/updateEmail';


const fn = { reducer, initialState, actions };
export default fn;
 